import { render, staticRenderFns } from "./CaptchaButton.vue?vue&type=template&id=e8ca4718&scoped=true&"
import script from "./CaptchaButton.vue?vue&type=script&lang=js&"
export * from "./CaptchaButton.vue?vue&type=script&lang=js&"
import style0 from "./CaptchaButton.vue?vue&type=style&index=0&id=e8ca4718&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e8ca4718",
  null
  
)

export default component.exports